<template>
    <div>
        <card-slides :contents="homepage.featured" />
        <promo />

        <trending :songs="homepage.trending" />

        <latest-podcasts :podcasts="homepage.episodes" />
        <events-slides :contents="homepage.events" v-if="homepage.events && homepage.events.length" />
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <popular-artists :artists="homepage.trendingArtists" />
            <popular-songs :songs="homepage.currentWeek" />
        </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import CardSlides from "@/components/CardSlides.vue";
import EventsSlides from "@/components/EventsSlides.vue";
import PopularSongs from "@/components/PopularSongs.vue";
import PopularArtists from "@/components/PopularArtists.vue";
import Trending from "@/components/Trending.vue";
import { Link, usePage } from "@inertiajs/vue3";
import { mapState, mapActions, } from "vuex";
import LatestPodcasts from "@/components/LatestPodcasts.vue";

export default {
    provide() {
        return {
            stream: this.$root.$data,
        };
    },
    beforeMount() {
        document.title = 'Heesify - Somali Music Lyrics & More';
    },
    mounted() {
        this.prepareHomepage();
    },
    computed: {
        ...mapState({
            homepage: (state) => state.homepage.all,
        }),
    },
    methods: {
        ...mapActions("homepage", ["prepareHomepage"]),
    },
    components: {
        "card-slides": CardSlides,
        "events-slides": EventsSlides,
        "popular-songs": PopularSongs,
        "popular-artists": PopularArtists,
        "trending": Trending,
        'latest-podcasts': LatestPodcasts,
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
        Link,
        AdsenseResponsive: defineAsyncComponent(() => import('@/components/AdsenseResponsive')),
        Promo: defineAsyncComponent(() => import('@/components/Promo'))
    },
};
</script>
